<template>
	<div>
		<h2>Заполните контактную информацию</h2>
		<p>Заполните заявку полностью, это увеличит вероятность одобрения</p>
		<formInput :refs="'PHONE'" ></formInput>
		<formInput  :refs="'EMAIL'" ></formInput>
		<formInput :refs="'FIRST_NAME'" ></formInput>
		<formInput :refs="'LAST_NAME'" ></formInput>
		<formInput :refs="'SECOND_NAME'" ></formInput>
		<formInput :refs="'BIRTHDAY'" ></formInput>
		<formSelectDadata :refs="'RESIDENTIAL_ADDRESS'" ></formSelectDadata>
		<label>Ваш пол:
			<formRadio :refs="'GENDER'" :sman="'M'"></formRadio>
			<formRadio :refs="'GENDER'" :sman="'F'"></formRadio>
			<p class="errorMsg" v-if="statusVuex['GENDER'].ShowError">{{statusVuex['GENDER'].msg}}</p>
		</label>
	</div>
</template>

<script>
import {mapState} from 'vuex'
export default {
	name: 'block1',
	data(){
		return {
		}
	},
	components:{
		formInput:        () => import('@/components/abt/form/abtInput'),
		formRadio:        () => import('@/components/abt/form/abtRadio'),
		formSelectDadata: () => import('@/components/abt/form/abtSelectDadata'),
	},
	methods: {
	},
	mounted() {
		this.$store.dispatch('hideLoading');
		window.dblClick = false;
	},
	computed: {
		...mapState({
			statusVuex: state => state.Form.workData,
			cookie: state => state.Cookie.cookie.Partner_Id,
		}),
	}
}
</script>
<style scoped>
.errorMsg { color: red; font-size: .4rem; padding-left: 1rem; }
@media (min-width: 768px) {
	.errorMsg { font-size: .8rem; }
}
</style>
